import type { GetPlatformV1AuditLogsParams } from '@nucleus-commerce/api-client/platform';

export const auditLogKeys = {
  all: ['audit-log'] as const,
  list: (params: GetPlatformV1AuditLogsParams) => [...auditLogKeys.all, params] as const,
};
